import { AppState } from '@chegg-wt/core/state'

export const featureFlagsSelector = (state: AppState) => state.featureFlags
export const ccpaSelector = (state: AppState) => state.featureFlags.ccpa
export const hideB1PlaceholderSelector = (state: AppState) =>
  state.featureFlags.hideB1Placeholder
export const lvpR3LayoutSelector = (state: AppState) => state.featureFlags.lvpR3
export const lvpLayoutSelector = (state: AppState) => state.featureFlags.lvp
export const stickyDisabledSelector = (state: AppState) =>
  state.featureFlags.stickyDisabled
export const backgroundThroughGamSelector = (state: AppState) =>
  !!state.featureFlags.backgroundThroughGam
export const backgroundIFrameUrl = (state: AppState) =>
  state.featureFlags.backgroundIFrameUrl

// these selector is for CTFM new layout experiment remove it once experiment is over
export const svpVariantSelector = (state: AppState) => state.featureFlags.variant
export const styleHomeSelector = (state: AppState) => state.featureFlags.styleHome

// selector for low ad EB and CM
export const adConfigVersionSelector = (state: AppState) =>
  state.featureFlags.adConfigVersion
